import React from "react";
import { InputNumber } from "antd";

const MoneyInput = ({ placeholder, ...props }) => (
  <InputNumber
    precision={0}
    step={1}
    min={0}
    suffix="บาท"
    formatter={(value) => {
      if (!value && value !== 0) return "";
      const integerPart = Math.trunc(value).toString();
      return integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }}
    parser={(value) => value?.replace(/,/g, "") || ""}
    size="large"
    placeholder={placeholder || "กรอกจำนวนเงิน"}
    style={{ width: "100%", color: "black" }}
    {...props}
  />
);

export default MoneyInput;
